import { FC, useMemo } from 'react';

import { StyleProps, useDisclosure } from '@bonusly/design-system';

import { Bonus as BonusData } from '../../../../../types/bonus';
import { Bonus } from './lib/bonus';
import { ReactionCounter } from './reaction-counter';
import { ReactionDetailsContext } from './reaction-detail-context';
import { ReactionModal } from './reaction-modal';

interface ReactionDetailProps extends StyleProps {
	bonus: BonusData;
}

export const ReactionDetails: FC<ReactionDetailProps> = ({ bonus: bonusData, ...rest }) => {
	const { isOpen, onOpen, onClose } = useDisclosure();

	// Ideally this would be done at a much higher level, ex. when bonus data from the API is
	// passed into the BonusFeedCard. However, the number of changes across the feed would be
	// extensive if that were to be done. For now we're limiting the data wrapper to just this
	// component but should look into raising this transformation up using a more suitable
	// tool in the future.
	const bonus = useMemo(() => new Bonus(bonusData), [bonusData]);

	return (
		<ReactionDetailsContext.Provider value={{ bonus }}>
			<ReactionCounter onClick={onOpen} {...rest} />
			<ReactionModal isOpen={isOpen} onClose={onClose} />
		</ReactionDetailsContext.Provider>
	);
};
